import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=3951e8cc&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitcher.vue?vue&type=style&index=0&id=3951e8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951e8cc",
  null
  
)

export default component.exports